import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Certificate.vue'
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
Vue.use(VueRouter)

//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },

  {
    path: '/expert',
    name: 'Expert',
    component: () => import(/* webpackChunkName: "Expert" */ '../views/Expert.vue')
  },
  {
    path: '/trade',
    name: 'Trade',
    component: () => import(/* webpackChunkName: "Expert" */ '../views/Trade.vue')
  },
  {
    path: '/utilities',
    name: 'utilities',
    component: () => import(/* webpackChunkName: "utilities" */ '../views/Utilities/indexNew.vue')
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/aboutUs/index.vue')
  },
  {
    path: '/jewelryEncyc',
    name: 'jewelryEncyc',
    component: () => import(/* webpackChunkName: "jewelryEncyc" */ '../views/jewelryEncyc/index.vue')
  },
  {
    path: '/queryResults',
    name: 'queryResults',
    component: () => import(/* webpackChunkName: "queryResults" */ '../views/queryResults/index.vue')
  },
  {
    path: '/articleContent',
    name: 'articleContent',
    component: () => import(/* webpackChunkName: "articleContent" */ '../views/articleContent/index.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/login.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
